import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AccordionModule, ButtonsModule, FeedbackModule, InputModule, LayoutModule, ModalsModule, StatusSpinnerModule } from '@skykick/core';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from '../shared/shared.module';
import { EmailRecipientsFormComponent } from './core/email-recipients-form/email-recipients-form.component';
import { GeneralNotificationsAdminCenterComponent } from './general-notifications-admin-center/general-notifications-admin-center.component';
import { NotificationsAdminCenterComponent } from './notifications-admin-center.component';
import { ProductNotificationsAdminCenterComponent } from './product-notifications-admin-center/product-notifications-admin-center.component';
import { NgHttpCachingStrategy, provideNgHttpCaching } from 'ng-http-caching';
import { NotificationDetailsPanelComponent } from './core/notifications-details-panel/notification-details-panel.component';
import * as moment from 'moment';
import { EmailRecipientsReadonlyInputComponent } from './core/email-recipients-readonly-input/email-recipients-readonly-input.component';

@NgModule({
  declarations: [
    NotificationsAdminCenterComponent,
    GeneralNotificationsAdminCenterComponent,
    ProductNotificationsAdminCenterComponent,
    EmailRecipientsFormComponent,
    NotificationDetailsPanelComponent,
    EmailRecipientsReadonlyInputComponent,
    NotificationDetailsPanelComponent
  ],
  imports: [
    CommonModule,
    LayoutModule,
    SharedModule,
    RouterModule,
    StatusSpinnerModule,
    FeedbackModule,
    ButtonsModule,
    ReactiveFormsModule,
    NgbModule,
    InputModule,
    ModalsModule,
    AccordionModule,
    ToastrModule.forRoot(),
    FormsModule
  ],
  providers: [
      provideNgHttpCaching({
        lifetime: moment.duration(10, 'minutes').asMilliseconds(),
        allowedMethod: ['GET'],
        cacheStrategy: NgHttpCachingStrategy.DISALLOW_ALL
      }),
  ]
})
export class NotificationsAdminCenterModule {}
